import { jsx as _jsx } from "react/jsx-runtime";
import { Trans } from 'react-i18next';
import { Alert } from 'src/shared/components/alert';
export function CoverInfo({ enabled }) {
    if (!enabled)
        return null;
    return (_jsx(Alert, { className: "my-5 text-small", children: _jsx(Trans, { i18nKey: "modules.form.cover.info", className: "text-small" }) }));
}
